module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "part-1-chapter-3",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-title-is-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-upper"
  }, [_c('span', {
    staticClass: "element-number-term"
  }, [_vm._v("CHAPTER")]), _vm._v(" "), _c('span', {
    staticClass: "element-number-number"
  }, [_vm._v("THREE")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "part-1-chapter-3-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width first-with-first-letter-j"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_vm._v("J")]), _vm._v("essica was always interested in other people.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jessica studied journalism at university.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jessica made friends.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jessica met Kurk, and she was infatuated by his name. What a cute and unique name. How funny that is; let’s laugh and banter and fall in love over a name.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("And they did that: fell in love. Or so Jessica thought.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jessica secured a job at a newspaper. She was a better journalist than she thought she’d be. Kurk, after dropping out of university, became a failed salesman, then a failed get-rich-quick guru, then a failed nothing. He managed to contain his anger to rants and cupboard-breaking for a time.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Then Jessica got pregnant; the pregnancy led her to agree to his proposal, though she wasn’t sure she wanted to marry him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jessica gave birth to Maisie, the cutest, funniest, most creative, most loving, precocious and sublime and brilliant and perfect girl who’s ever lived.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Kurk got angry when Jessica wouldn’t let him hurt Maisie, so he hurt Jessica instead.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Jessica mustered her courage and asked for a divorce.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Kurk said no.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("She pressed, and The Night happened.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The Night was when Kurk locked Jessica and Maisie in their respective bedrooms and set fire to the house. The Night was when Jessica, after almost shattering her hands to bash her door open, wailed and screamed and hammered her fists on her daughter’s door, but realised something was blocking it.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The Night was when Kurk died, Maisie died, and Jessica lived.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The Night was when Jessica fled the house; her primal instincts taking over, she would later tell herself, and she ran. There was no other choice.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("The Night was when Jessica stopped thinking of herself as a person.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Or thinking at all if she could help it.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72daf222","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/part001chapter003.vue
// module id = 84
// module chunks = 0